import React, { useState, useEffect, useRef } from 'react';
import AppBaseComponent from '../../../components/AppBaseComponent';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { useSelector } from "react-redux";
import Ax from "../../../components/hoc/Ax";
import moment from "moment";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { PeriodSelectionWithCustom, DisplaySearchCriteria, DisplayListPagination } from "../../../components/TapUi/index";
import TapSelect from "../../../components/ui/TapSelect";
import Helmet from 'react-helmet';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapIcon from '../../../services/TapIcon';
import ProductivityComparisonGraph from './ProductivityComparisonPeriodGraph';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import ProgressBarComparison from './ProductivityComparisonPeriodGraph';

const AssetWiseProductivityPeriodComparisonReport = (props) => {

    const setting               =    useSelector(state => state.app.setting)

    const access_token = useSelector(state => state.auth.access_token);
    const iam_asset_types = useSelector(state => state.app?.asset_type || []);
    const iam_user_sites = useSelector(state => state.app?.user_sites || []);
    const group_sites = useSelector(state => state.app?.group_sites || []);
    const iam_asset_matrix = useSelector(state => state.app?.asset_matrix || []);
    const asset_groups = useSelector(state => state.app?.asset_groups || []);
    const all_periods = useSelector(state => {
        const periods = state.app?.all_periods || [];
        return [...periods, { key: 'custom', display: 'Custom Date Range' }];
    });
    const site_groups = useSelector(state => state.app?.site_groups || []);
    const report_listing = useSelector(state => state.app?.report_listing || []);

    const reportFilterFormInitialState = {
        search_asset_ids: [],
        site_group_ids: [],
        search_site_ids: [],
        asset_group_ids: [],
        search_asset_type_ids: [],
        search_asset_matrix_ids: [],
        date_range1: '',
        date_range2: '',
        date_range3: '',
        search_activities: [],
        search_units: [],
        search_material_ids: [],
        search_attachment_ids: [],
        date_range_start1: '',
        date_range_end1: '',
        date_range_start2: '',
        date_range_end2: '',
        date_range_start3: '',
        date_range_end3: '',
        show_filter: true
    };

    const reportFilterFormLabel = {
        search_asset_ids: 'Assets : ',
        site_group_ids: 'Site Groups : ',
        search_site_ids: 'Sites : ',
        asset_group_ids: 'Asset Type Groups : ',
        search_asset_type_ids: 'Asset Type : ',
        search_asset_matrix_ids: 'Asset Matrix : ',
        date_range1: 'Date Range1 : ',
        date_range2: 'Date Range2 : ',
        date_range3: 'Date Range3 : ',
        search_activities: 'Activities : ',
        search_units: 'Units : ',
        search_material_ids: 'Materials : ',
        search_attachment_ids: `${setting?.attachment_name} : `,
    };

    const [formDataLoaded, setFormDataLoaded] = useState(false);
    const [reportFilterForm, setReportFilterForm] = useState(reportFilterFormInitialState);
    const [submittedReportFilterForm, setSubmittedReportFilterForm] = useState(reportFilterFormInitialState);
    const [listing_loading, setListingLoading] = useState(false);
    const [listingData, setListingData] = useState([]);
    const [filterFormData, setFilterFormData] = useState(null);
    const [allSiteGroupsList, setAllSiteGroupsList] = useState([]);
    const [allAssetTypesGroupsList, setAllAssetTypesGroupsList] = useState([]);
    const [activities, setActivities] = useState([]);
    const [units, setUnits] = useState([]);
    const [materials, setMaterials] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [period1, setPeriod1] = useState('');
    const [period2, setPeriod2] = useState('');
    const [period3, setPeriod3] = useState('');
    const [criteriaHeight, setCriteriaHeight] = useState(0);
    const [formSearchedElems, setFormSearchedElems] = useState([]);
    const [reportName, setReportName] = useState({});
    const [reportSubmitted, setReportSubmitted] = useState(false);
    const [showFilterForm, setShowFilterForm] = useState(true);
    const [listingMeta, setListingMeta] = useState(null);
    const [searchedAssets, setSearchedAssets] = useState([]);
    const [iam_group_sites, setIam_group_sites] = useState([])
    const criteriaRef = useRef(null);
    const formDataUrl = IAM_API_BASE_URL_2 + '/report/productivity-report';
    const reportUrl = IAM_API_BASE_URL_2 + '/report/productivity_asset_wise';


    // Initialize app data
    useEffect(() => {
        initilaizeAppDataToFilterForm(props);
    }, []);

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height);
            }
        }
    };

    useEffect(() => {
        updateCriteriaHeight();
    }, [formSearchedElems]);

    const initilaizeAppDataToFilterForm = (props) => {
        const report_name = props?.location?.pathname ? props.location.pathname.split('/')[2] : '';
        const reportData = report_listing.length > 0 ? report_listing.filter(d => d.key === report_name) : [];

        setReportName(reportData.length > 0 ? reportData[0] : null);

        const mappedAssetTypes = iam_asset_types ? iam_asset_types.map((at) => ({ value: at.id, label: at.asset_type_name })) : [];
        const mappedUserSites = iam_user_sites ? iam_user_sites.map((s) => ({ value: s.id, label: `${s.site_name} (${s.site_code})` })) : [];
        const mappedAssetMatrix = iam_asset_matrix ? iam_asset_matrix.map(am => ({ value: am.id, label: am.asset_matrix_unique_id })) : [];
        const mappedAssetGroups = asset_groups && asset_groups.length > 0 ? asset_groups.map(oc => ({ value: oc.id, label: oc.name, linked_asset_types: oc.asset_type_ids })) : [];
        const mappedSiteGroups = site_groups ? site_groups.map(oc => ({ value: oc.id, label: oc.name, linked_sites: oc.site_ids })) : [];
        setAllSiteGroupsList(mappedSiteGroups);
        setAllAssetTypesGroupsList(mappedAssetGroups);
        setIam_group_sites(group_sites ? group_sites.map((s) => ({ value: s.id, label: `${s.site_name} (${s.site_code})` })) : [])
        setFilterFormData({
            iam_asset_types: mappedAssetTypes,
            iam_user_sites: mappedUserSites,
            iam_asset_matrix: mappedAssetMatrix,
            allPeriods: all_periods
        });

        setReportFilterForm(prev => ({
            ...prev,
            date_range1: '',
            date_range2: '',
            date_range3: '',
            show_filter: true
        }));

        filterFormDataInit();
    };

    const filterFormDataInit = () => {
        setFormDataLoaded(true);
        HttpAPICall.withAthorization('GET', formDataUrl, access_token, { action: 'formData' }, null, (response) => {
            let respData = response.data;
            const mappedActivities = respData.activity_name ? respData.activity_name.map((s) => ({ value: s.id, label: s.activity_name })) : [];
            const mappedUnits = respData.uom ? respData.uom.map((s) => ({ value: s.id, label: s.measuring_unit })) : [];
            const mappedMaterials = respData.materials ? respData.materials.map((s) => ({ value: s.id, label: s.material_name })) : [];
            const mappedAttachments = respData.attachments ? respData.attachments.map((s) => ({ value: s.id, label: s.name })) : [];
            setActivities(mappedActivities);
            setUnits(mappedUnits);
            setMaterials(mappedMaterials);
            setAttachments(mappedAttachments);
        }).then(() => {
            setFormDataLoaded(false);
        });
    };

    const reportFilterFormSubmit = (event = null, isAutoSubmit = false) => {
        if (event) {
            event.preventDefault();
        }

        let serachFormKeys = Object.keys(reportFilterForm);
        let searchedElems = [];

        serachFormKeys.forEach((key) => {
            let label = reportFilterFormLabel[key];
            let value = reportFilterForm[key];

            if (value && (Array.isArray(value) ? value.length > 0 : value.toString().length > 0)) {
                if (label) {
                    let show_val = value;

                    if (key == 'search_asset_ids') {
                        console.log("jh");

                        show_val = searchedAssets ? searchedAssets.map(s => s.display_label).join(', ') : '';
                    }
                    if (key === 'asset_group_ids') {
                        show_val = allAssetTypesGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    } else if (key === 'search_asset_type_ids') {
                        show_val = filterFormData?.iam_asset_types?.filter((s) => value.includes(s.value)).map(s => s.label).join(', ') || '';
                    } else if (key === 'site_group_ids') {
                        show_val = allSiteGroupsList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    } else if (key === 'search_site_ids') {
                        show_val = filterFormData?.iam_user_sites?.filter((s) => value.includes(s.value)).map(s => s.label).join(', ') || '';
                    } else if (key === 'search_asset_matrix_ids') {
                        show_val = filterFormData?.iam_asset_matrix?.filter((s) => value.includes(s.value)).map(s => s.label).join(', ') || '';
                    } else if (key === 'search_activities') {
                        show_val = activities.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    } else if (key === 'search_units') {
                        show_val = units.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    } else if (key === 'search_material_ids') {
                        show_val = materials.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    } else if (key === 'search_attachment_ids') {
                        show_val = attachments.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    } else if (key === 'date_range1') {
                        if (value === 'custom') {
                            let start_range = moment(reportFilterForm.date_range_start1).format('DD-MMM-YYYY');
                            let end_range = moment(reportFilterForm.date_range_end1).format('DD-MMM-YYYY');
                            show_val = `Custom Date Range (${start_range} - ${end_range})`;
                        } else {
                            const period = filterFormData?.allPeriods?.find(p => p.key === value);
                            show_val = period ? (period.display_with_date || period.display) : value;
                        }
                    } else if (key === 'date_range2') {
                        if (value === 'custom') {
                            let start_range = moment(reportFilterForm.date_range_start2).format('DD-MMM-YYYY');
                            let end_range = moment(reportFilterForm.date_range_end2).format('DD-MMM-YYYY');
                            show_val = `Custom Date Range (${start_range} - ${end_range})`;
                        } else {
                            const period = filterFormData?.allPeriods?.find(p => p.key === value);
                            show_val = period ? (period.display_with_date || period.display) : value;
                        }
                    }
                    else if (key === 'date_range3') {
                        if (value === 'custom') {
                            let start_range = moment(reportFilterForm.date_range_start3).format('DD-MMM-YYYY');
                            let end_range = moment(reportFilterForm.date_range_end3).format('DD-MMM-YYYY');
                            show_val = `Custom Date Range (${start_range} - ${end_range})`;
                        } else {
                            const period = filterFormData?.allPeriods?.find(p => p.key === value);
                            show_val = period ? (period.display_with_date || period.display) : value;
                        }
                    }
                    if (show_val) {
                        searchedElems.push(label + `<b>${show_val}</b>`);
                    }
                }
            }
        });

        setSubmittedReportFilterForm({ ...reportFilterForm });
        setFormSearchedElems(searchedElems);
        setReportSubmitted(true);

        if (!isAutoSubmit) {
            setShowFilterForm(false);
            setReportFilterForm(prev => ({ ...prev, show_filter: false }));
        }

        loadListingTblData(reportFilterForm, 1);
    };

    const loadListingTblData = (submittedData, page = 1) => {
        setListingLoading(true);
         const periods = [];
        if (submittedData.date_range1) {
            periods.push({
                date_range: submittedData.date_range1,
                date_range_start: submittedData.date_range_start1,
                date_range_end: submittedData.date_range_end1
            });
        }

        if (submittedData.date_range2) {
            periods.push({
                date_range: submittedData.date_range2,
                date_range_start: submittedData.date_range_start2,
                date_range_end: submittedData.date_range_end2
            });
        }

        if (submittedData.date_range3) {
            periods.push({
                date_range: submittedData.date_range3,
                date_range_start: submittedData.date_range_start3,
                date_range_end: submittedData.date_range_end3
            });
        }

        const payload = {
            site_group_ids: submittedData.site_group_ids || [],
            search_site_ids: submittedData.search_site_ids || [],
            asset_group_ids: submittedData.asset_group_ids || [],
            search_asset_type_ids: submittedData.search_asset_type_ids || [],
            search_asset_matrix_ids: submittedData.search_asset_matrix_ids || [],
            search_activities: submittedData.search_activities || [],
            search_units: submittedData.search_units || [],
            search_material_ids: submittedData.search_material_ids || [],
            search_attachment_ids: submittedData.search_attachment_ids || [],
            search_asset_ids: submittedData.search_asset_ids || [],
            show_filter: submittedData.show_filter,
            periods: periods,
            action: "data",
        }

        HttpAPICall.withAthorization('POST', reportUrl, access_token, { page }, payload, (response) => {
            let respData = response.data;
            if (respData.periods && respData.periods.length > 0) {
                setPeriod1(respData.periods[0]?.display_with_date || '');
                setPeriod2(respData.periods[1]?.display_with_date || '');
                setPeriod3(respData.periods[2]?.display_with_date || '');
            }
            setListingData(respData.assets?.data || []);
            setListingMeta({
                from: respData.assets?.from,
                to: respData.assets?.to,
                total: respData.assets?.total,
                last_page: respData.assets?.last_page,
                per_page: respData.assets?.per_page,
                current_page: respData.assets?.current_page
            });
        }).catch(error => {
            console.error("API Error:", error);
        }).finally(() => {
            setListingLoading(false);
        });
    };


    const toggleFilterForm = () => {
        setShowFilterForm(!showFilterForm);
        setReportFilterForm(prev => ({ ...prev, show_filter: !showFilterForm }));

        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    };

    const closeReport = () => {
        props.history.push('/report');
    };

    const tapSelectChange = (selectedOption, fieldName) => {
        const value = selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [];
        setReportFilterForm(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };

    const pageTitleBarJsx = () => {
        return (
            <div className="page_title row m0">
                <div className="col-sm-12">
                    <h3><TapIcon.FontAwesomeIcon icon={TapIcon.faCubes} /> {reportName?.name}</h3>
                    <div className="text-end mt15">
                        <button type="button" onClick={toggleFilterForm} className="btn btn-secondary">
                            {showFilterForm ? 'Change Filter' : 'Change Filter'}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={closeReport}>
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const reportFilterFormJsx = () => {
        return (
            <div id="reportFilterForm" className="bg-white" style={{ display: showFilterForm ? 'block' : 'none' }}>
                <form onSubmit={reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')} >
                    <div className="row mb-3">
                        <label className="col-sm-3 col-form-label col-form-label-sm text-end">Asset</label>
                        <div className="col-sm-8">
                            <InputAssetSearch
                                changeEvent={(selectedOption) => {
                                    const selectedAssets = selectedOption && selectedOption.length > 0 ? selectedOption : [];
                                    setSearchedAssets(selectedAssets);
                                    setReportFilterForm(prev => ({
                                        ...prev,
                                        search_asset_ids: selectedAssets.map(a => a.value)
                                    }));
                                }}
                                isMulti={true}
                                menuPlacement="bottom"
                                value={
                                    searchedAssets.length > 0
                                        ? searchedAssets.map(a => ({ ...a, label: a.display_label }))
                                        : []
                                }
                            />

                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Asset Type Group</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={allAssetTypesGroupsList}
                                changeEvent={(selectedOption) => {
                                    setReportFilterForm(prev => ({
                                        ...prev,
                                        asset_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                        search_asset_type_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_asset_types).flat() : []
                                    }));
                                }}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={allAssetTypesGroupsList.filter(s => reportFilterForm.asset_group_ids.includes(s.value))}
                                placeholder="Select Asset Type Group"
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Asset Type</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={filterFormData?.iam_asset_types || []}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_asset_type_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={(filterFormData?.iam_asset_types || []).filter(s => reportFilterForm.search_asset_type_ids.includes(s.value))}
                                placeholder="Select Asset Type"
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Asset Matrix</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={filterFormData?.iam_asset_matrix || []}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_asset_matrix_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={(filterFormData?.iam_asset_matrix || []).filter(s => reportFilterForm.search_asset_matrix_ids.includes(s.value))}
                                placeholder="Select Asset Matrix"
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-3 col-form-label text-end"> Asset Site Group</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={allSiteGroupsList}
                                changeEvent={(selectedOption) => {
                                    setReportFilterForm(prev => ({
                                        ...prev,
                                        site_group_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : [],
                                        search_site_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(s => s.linked_sites).flat() : []
                                    }));
                                }}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={allSiteGroupsList.filter(s => reportFilterForm.site_group_ids.includes(s.value))}
                                placeholder="Select Site Group"
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-3 col-form-label text-end"> Asset Site Name</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={filterFormData?.iam_user_sites || []}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_site_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={(filterFormData?.iam_user_sites || []).filter(s => reportFilterForm.search_site_ids.includes(s.value))}
                                placeholder="Select Sites"
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Activities</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={activities}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_activities')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={activities.filter(s => reportFilterForm.search_activities.includes(s.value))}
                                placeholder="Select Activities"
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Units</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={units}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_units')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={units.filter(s => reportFilterForm.search_units.includes(s.value))}
                                placeholder="Select Units"
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Materials</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={materials}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_material_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={materials.filter(s => reportFilterForm.search_material_ids.includes(s.value))}
                                placeholder="Select Materials"
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">{setting?.attachment_name ? setting?.attachment_name : 'Attachments'}</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={attachments}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_attachment_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={attachments.filter(s => reportFilterForm.search_attachment_ids.includes(s.value))}
                                placeholder={`Select ${setting?.attachment_name ? setting?.attachment_name : 'Attachments'}`}
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end require">Select Period 1</label>
                        <div className="col-sm-8">
                            <PeriodSelectionWithCustom
                                periods={filterFormData?.allPeriods || []}
                                value={reportFilterForm.date_range1}
                                startDate={reportFilterForm.date_range_start1}
                                endDate={reportFilterForm.date_range_end1}
                                onSelectPeriod={(period, startDate, endDate) => {
                                    setReportFilterForm(prev => ({
                                        ...prev,
                                        date_range1: period,
                                        date_range_start1: startDate ? startDate : '',
                                        date_range_end1: endDate ? endDate : ''
                                    }));
                                }}
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Select Period 2</label>
                        <div className="col-sm-8">
                            <PeriodSelectionWithCustom
                                periods={filterFormData?.allPeriods || []}
                                value={reportFilterForm.date_range2}
                                startDate={reportFilterForm.date_range_start2}
                                endDate={reportFilterForm.date_range_end2}
                                onSelectPeriod={(period, startDate, endDate) => {
                                    setReportFilterForm(prev => ({
                                        ...prev,
                                        date_range2: period,
                                        date_range_start2: startDate ? startDate : '',
                                        date_range_end2: endDate ? endDate : ''
                                    }));
                                }}
                            />
                        </div>
                    </div>
                    <div className="row my-3">
                        <label className="col-sm-3 col-form-label text-end">Select Period 3</label>
                        <div className="col-sm-8">
                            <PeriodSelectionWithCustom
                                periods={filterFormData?.allPeriods || []}
                                value={reportFilterForm.date_range3}
                                startDate={reportFilterForm.date_range_start3}
                                endDate={reportFilterForm.date_range_end3}
                                onSelectPeriod={(period, startDate, endDate) => {
                                    setReportFilterForm(prev => ({
                                        ...prev,
                                        date_range3: period,
                                        date_range_start3: startDate ? startDate : '',
                                        date_range_end3: endDate ? endDate : ''
                                    }));
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="pb-3 col-9 text-end">
                            <button type="submit" disabled={listing_loading} className="btn btn-primary px-4">
                                Show Report
                            </button>
                        </div>
                        <hr />
                    </div>
                </form>
            </div>
        );
    };

   const reportTableJsx = () => {
    const getGlobalMinMax = (data = []) => {
        let values = [];

        data.forEach(asset => {
            if (asset.productivities && asset.productivities.length > 0) {
                asset.productivities.forEach(prod => {
                    if (prod.productivity && !isNaN(parseFloat(prod.productivity))) {
                        values.push(parseFloat(prod.productivity));
                    }
                });
            }
        });

        return {
            min: 0,  
            max: values.length > 0 ? Math.max(...values) : 1, 
        };
    };


    const { min: globalMin, max: globalMax } = getGlobalMinMax(listingData);
    
   
    const periodLabels = [];
    if (period1) periodLabels.push(period1);
    if (period2) periodLabels.push(period2);
    if (period3) periodLabels.push(period3);

    return (
        <Ax>
            <table className="table table-bordered bg-white align-items-center table-sm " id="rowDataReportTable">
                <thead className="align-middle table-secondary" style={{
                    top: `${criteriaHeight}px`,
                    position: 'sticky',
                }}>
                    <tr>
                        <th scope="col" style={{ width: "4%" }} className='text-center'>S.No</th>
                        <th scope="col" style={{ width: "11%" }} className='text-center'>Asset Name</th>
                        <th scope="col" style={{ width: "11%" }} className='text-center'>Asset Code</th>
                        <th scope="col" style={{ width: "11%" }} className='text-center'>Asset Type</th>
                        <th scope="col" style={{ width: "11%" }} className='text-center'>Current Site</th>
                        <th scope="col" style={{ width: "52%" }}>Graph</th>
                    </tr>
                </thead>
                <tbody>
                    {listing_loading ? (
                        <tr><td className="text-center" colSpan={6}><Loader /></td></tr>
                    ) : listingData && listingData.length > 0 ? (
                        <Ax>
                            {listingData.map((asset, index) => {
                
                                const productivities = asset.productivities || [];
                                const values = productivities.map(p => parseFloat(p.productivity) || 0);
                                
                               
                                
                                return (
                                    <tr key={asset?.asset_id || index} >
                                        <td className='text-center'>{listingMeta ? listingMeta?.from + index : index}</td>
                                        <td className='text-center'>{asset?.name || ''}</td>
                                        <td className='text-center'>{asset?.asset_code || ''}</td>
                                        <td className='text-center'>{asset?.asset_type || ''}</td>
                                        <td className='text-center'>{asset?.site || ''}</td>
                                        <td>
                                            <ProgressBarComparison
                                                values={values}
                                                unit="" 
                                                minValue={globalMin}
                                                maxValue={globalMax}
                                                labels={periodLabels}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </Ax>
                    ) : (
                        <tr><td className="text-center" colSpan={6}>No Record Found</td></tr>
                    )}
                </tbody>
            </table>
            <DisplayListPagination
                meta={listingMeta}
                onPageChange={(e) => loadListingTblData(submittedReportFilterForm, e.selected + 1)}
            />
        </Ax>
    );
};

    const reportListingDisplayJsx = () => {
        return (
            <div className="bg-white">
                {reportTableJsx()}
            </div>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Productivity Period Comparison - Report</title></Helmet>
            {pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        {formDataLoaded ? <Loader /> : reportFilterFormJsx()}

                        {reportSubmitted && (
                            <>
                                {formSearchedElems.length > 0 && (
                                    <div
                                        ref={criteriaRef}
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                            marginTop: showFilterForm ? '20px' : '0'
                                        }}
                                    >
                                        <DisplaySearchCriteria searchedElems={formSearchedElems} />
                                    </div>
                                )}
                                {reportListingDisplayJsx()}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    );
};

export default AssetWiseProductivityPeriodComparisonReport;